<template>
<div class="container" id="post_wrap">
	
	<div v-if="post_id > 0">
		<h4 class="gold">
			<small @click="goto_page('/post/' + post_id)" class="gold pointer">
				Back to Post <i class="fas fa-chevron-left"></i>
			</small> edit <span v-text="post_type"></span>
		</h4>
		
		<b-card>
			<div class="row">
				<div class="col-md-12">
					<b-form @submit="postUpdate">
						<b-form-group>
							<b-form-input
								id="title"
								v-model="reply.title"
								type="text"
								required
								placeholder="Enter Reply Header"
								maxlength="150"
							></b-form-input>
						</b-form-group>
						
						<b-form-group>
							<label><small class="gold">
							* To post a YouTube or Vimeo video, just paste the URL into the textarea below (each video link on a new line).
							</small></label>
							<b-form-textarea
								id="textarea"
								v-model="reply.main_text"
								placeholder="What have you got to say?"
								rows="20"
								max-rows="20"
							></b-form-textarea>
						</b-form-group>
						
						
						<h5 v-if="error_message != ''" v-text="error_message" class="text-danger"></h5>
						
						<div class="row">
							<div class="col">
								<b-button type="submit" variant="primary">
									<i class="far fa-hand-point-right"></i> Submit Update
								</b-button>
						
								<b-button type="button" variant="outline-secondary" @click="goto_page('/post/' + post_id)">
									<i class="fas fa-times"></i> Cancel
								</b-button>
							</div>
							<div class="col text-right">
								<b-dropdown text="Delete" dropleft size="sm" variant="outline-danger" class="ml-2">
									<b-dropdown-item @click="confirmDelete($event)">Confirm</b-dropdown-item>
								</b-dropdown>
							</div>
						</div>
						
					</b-form>

				</div>
			</div>
		</b-card>

	</div>
	
	<div v-else>
		<div class="text-center gold my-2 p-2">
			<b-spinner class="align-middle"></b-spinner>
			<br />
			<strong>Loading...</strong>
		</div>
	</div>
	

  
	
</div>
</template>


<script>
import axios from "axios";

export default {
	name: "PostEdit",
	props: {
	},
	data() {
		return {
			error_message: '',
			deleteit: 0,
			reply: {
				title: '',
				main_text: '',
			},
			post: [],
			session_id: this.$store.state.session_id,
			temp : null,
		}
	},
	computed:{
		post_id(){
			var post_id = 0;
			if(this.$route.params.post_id){
				post_id = this.$route.params.post_id;
			}
			return post_id;
		},
		post_type(){
			var post_type = 'post';
			if(this.$route.params.reply_id > 0){
				post_type = 'reply';
			}
			return post_type;
		},
		reply_id(){
			var reply_id = 0;
			if(this.$route.params.reply_id){
				reply_id = this.$route.params.reply_id;
			}
			return reply_id;
		},
	},
	methods:{
		
		confirmDelete(e){
			this.deleteit = 1;
			this.postUpdate(e);
		},
		
		goto_page(page){
			this.$router.push(page);
		},
		
		postUpdate(e){
			let _this = this;
			var URL = null;
			e.preventDefault();
			
			console.log('postUpdate');

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('type', this.post_type);
			params.append('title', this.reply.title);
			params.append('main_text', this.reply.main_text);
			
			if(this.deleteit == 1){
				params.append('delete', this.deleteit);
			}
			
			if(this.$route.params.reply_id > 0){
				params.append('reply_id', this.reply_id);
				URL = _this.$store.state.api_url + "forum/replyUpdate";
			}
			else
			{
				params.append('post_id', this.post_id);
				URL = _this.$store.state.api_url + "forum/postUpdate";
			}

			axios({
				method: 'post',
				url: URL,
				data: params,

			}).then(function (response) {
				if(response.data.status == 1){
					_this.$router.push('/post/' + _this.post_id);
				}
				else if(response.data.status == 5){
					_this.$router.push('/dashboard');
				}
				else{
					_this.error_message = response.data.message;
				}
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		postGet(){
			console.log('postGet');
			let _this = this;
			var URL = '';

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('type', 'edit');
			
			if(this.$route.params.reply_id > 0){
				params.append('reply_id', this.$route.params.reply_id);
				URL = _this.$store.state.api_url + "forum/replyGet";
			}
			else
			{
				params.append('post_id', this.$route.params.post_id);
				URL = _this.$store.state.api_url + "forum/postsGet";
			}
			

			axios({
				url: URL,
				params: params,

			}).then(function (response) {
				
				var post = null;
				
				if(response.data.post){
					post = Object.values(response.data.post);
					_this.post = post[0];
					
					_this.reply.title = _this.post.title;
					_this.reply.main_text = _this.post.main_text;
				}
				else if(response.data.replies){
					post = Object.values(response.data.replies);
					_this.post = post[0];
					
					_this.reply.title = _this.post.title;
					_this.reply.main_text = _this.post.main_text;
				}
				
				
			}).catch(function (error) {
				console.log(error);
			});
		},

	},
	mounted() {
		this.postGet();
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
